"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const CheckmarkIcon_1 = require("./Icons/CheckmarkIcon");
const CheckBox = ({ checked, onClick, value }) => {
    if (checked) {
        return (React.createElement("div", { style: {
                width: 16,
                height: 16,
                borderRadius: 3,
                background: colors_1.turquoise,
                margin: 4,
            }, onClick: () => onClick(value) },
            React.createElement(CheckmarkIcon_1.default, { fill: colors_1.white })));
    }
    else {
        return (React.createElement("div", { style: {
                width: 16,
                height: 16,
                borderRadius: 3,
                border: `2px solid ${colors_1.titanium}`,
                margin: 4,
            }, onClick: () => onClick(value) }));
    }
};
exports.default = CheckBox;
